import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-placement',
    templateUrl: './placement.component.html',
    styleUrls: ['./placement.component.scss']
})
export class PlacementComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Placement – Achieve Your Career Goals with Top Companies');
        this.meta.updateTag({
            name: 'description',
            content: `Explore ARNI Placement opportunities and connect with leading companies for job placements, internships, and career growth.`
        });
    }

}
